// @flow

// import type { OperationComponent, QueryProps } from "react-apollo";
// import type { ProjectType } from "./projects";

import gql from "graphql-tag";
import { graphql } from "react-apollo";

const retrieveProjectQuery = gql`
  query($projectId: ID) {
    Project(id: $projectId) {
      id
      name
      template
      hasObjectiveAnswers
    }
  }
`;

// FIXME:
// export type retrieveProjectQueryResult = {
//   projectData: {
//     Project: ProjectType // Capitalized to match the gql query above.
//   } & QueryProps
// };

export type retrieveProjectQueryResult = Object;

// FIXME:
// export const withRetrieveProject: OperationComponent<retrieveProjectQueryResult, { projectId: string }> = ...

export const withRetrieveProject: any = graphql(retrieveProjectQuery, {
  options: ({ projectId }) => ({
    variables: { projectId }
  }),
  name: "projectData"
});



// WEBPACK FOOTER //
// ./src/data/project.js